/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";

export function ProjectCategoryDeleteDialogHeader({ id }) {
  const [title, setTitle] = useState("");
  // Channel Redux state
  const { projectCategoryForEdit, actionsLoading } = useSelector(
    (state) => ({
      projectCategoryForEdit: state.projectCategory.projectCategoryForEdit,
      actionsLoading: state.projectCategory.actionsLoading,
    }),
    shallowEqual
  );

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="modal-sizes-title-lg">
          Delete Kategori Penyaluran
        </Modal.Title>
      </Modal.Header>
    </>
  );
}
